<template>
	<div class="news">
		<div class="banner">
			<img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/banner-notice.jpg" />
			<div class="text">
				<img src="../../assets/images/banner-news-text.png" />
			</div>
		</div>
		<div class="block-wrap">
			<Breadcrumbs :routes="breadRoutes" />
			<div class="flex">
				<div class="types-wrap">
					<div class="type-item hand"
								:class="item.id === category ? 'active' : ''"
								v-for="(item, index) in categories"
								:key="index"
								@click="onCategoryChange(item)">{{item.name}}</div>
				</div>
				<div class="search-box">
					<input type="text" placeholder="请输入名称搜索" v-model="searchName" />
					<div class="search-btn" @click="searchData">
						搜索
					</div>
				</div>
			</div>
      <div class="content-wrap">
      	<div class="news-list-wrap">
	        <div class="news-item" v-for="(n, index) in listData" :key="index">
	          <h3 class="hand" @click="toNewsDetail(n)">
	            {{n.title}}
	          </h3>
	          <div class="news-info-detail">
	            <div class="news-time">
		            <b>{{n._year}}</b>
		            <span>{{n._md}}</span>
		          </div>
	            <div class="news-title">{{n.briefIntroduction}}</div>
	          </div>
	          <div class="card-more" @click="toNewsDetail(n)">查看详情</div>
	        </div>
	        <Pagination :currentPage="currentPage" :total="total" @change="pageChange" />
	      </div>
				<div class="card-list-wrap" @click="toAward(1)">
					<div class="card-header">
						<div class="card-header-bg"></div>
						<div class="card-header-header">
							<div class="card-header-header-title">等级评价活动通知公告</div>
						</div>
						<div class="card-header-body">
							2023年度浙江省园林绿化工程施工安全生产标准化管理优良工地
						</div>
					</div>
					<!-- <div class="card-item">
						<img class="card-item-bg" src="../../assets/tempImages/ccd.png" />
						<div class="card-item-info">
							<div class="card-item-info-title">浙江园林绿化信息</div>
							<div class="card-item-info-little-title">一个月一次｜内刊</div>
							<div class="card-item-info-desc">风景园林规划设计中的植物景观景题创作是对中国 优秀园林文化的传承。通过对古典园林植物景观</div>
						</div>
					</div> -->
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import router from '@/router';
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from '@/components/Pagination';
import { getNewsList } from './service/api';

export default {
  data() {
    return {
    	breadRoutes: [{
    		href: '/',
    		name: '首页'
    	}, {
    		name: '学会新闻'
    	}],
      categories: [
        {
          name: "学会工作简讯",
          id: 7001,
        },
        {
          name: "省外动态信息",
          id: 7002,
        },
        {
          name: "省内动态信息",
          id: 7003,
        },
        {
          name: "各地专栏信息",
          id: 7004,
        }
      ],
      category: 7001,
    	listData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
			searchName: ''
    }
  },
  components: {
    Breadcrumbs,
    Pagination
  },
	mounted() {
		let activeIdx  = router.currentRoute.query.activeIdx;
		if(activeIdx == 0 ){
			this.category = 7001
		}
		if(activeIdx == 1 ){			
			this.category = 7002
		}
		this.init();	
	},
  methods: {
		searchData() {
      this.pageChange(1);
    },	
		init() {
			this.getList();
		},
    onCategoryChange(item) {
      this.category = item.id;
			this.currentPage = 1;
      this.getList();
    },
		getList() {
			const params = {
        title: this.searchName,
        current: this.currentPage,
        pageSize: this.pageSize,
        categoryDicKey: this.category,
      };
      getNewsList(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
					const date = moment(item.releaseDate*1000);
          item._year = date.format("YYYY");
					item._md = date.format("MM-DD");
          return item;
        });
      });
		},
    pageChange(page) {
      this.currentPage = page;
			this.getList();
    },
		linkTo(uri) {
			router.push(uri);
		},
		toNewsDetail(item) {
			this.linkTo(`/news/detail?aId=${item.id}`);
		},
		toAward(item) {
			this.linkTo(`/activity/awards?aId=${item}`);
		}
  }
}

</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.banner {
	width: 100%;
	min-width: @middleWidth;
	margin-bottom: 20px;
	position: relative;

	img {
		display: block;
		width: 100%;
	}

	.text {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);

		> img {
			width: 297px;
		}
	}
}
.types-wrap {
  display: flex;
  align-items: center;
	margin-bottom: 20px;

  .type-item {
    width: 96px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #9D9E9E;

    &.active {
      background: #F1F3F3;
      color: #131415;
    }
  }
}

.content-wrap {
	padding-top: 20px;
	padding-bottom: 50px;
	display: flex;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 1px;
		opacity: 0.2;
		background: #9D9E9E;
	}

	.news-list-wrap {
		flex: 1;
		padding-right: 20px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;

    .news-item {
	    width: 100%;
			background: rgba(253,255,253, 0.9500);
	    padding: 20px 160px 20px 20px;
	    position: relative;
			border: 4px solid transparent;

	    &::after {
	      content: '';
	      position: absolute;
	      left: 0;
	      bottom: -4px;
	      width: 100%;
	      height: 1px;
	      opacity: 0.2;
	      background: #9D9E9E;
	    }

	    // &:first-child {
	    // 	&::before {
		  //     content: '';
		  //     position: absolute;
		  //     left: 0;
		  //     top: 0;
		  //     width: 100%;
		  //     height: 1px;
		  //     opacity: 0.2;
		  //     background: #9D9E9E;
		  //   }
	    // }

			&:nth-last-child(2) {
				margin-bottom: 30px;
			}

	    &:hover {
	    	background: #F1F3F3;
				border-color: #06AE63;
	    }

	    > h3 {
	      &:extend(.line1);
	      width: 100%;
				height: 25px;
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #131415;
				line-height: 25px;
				margin-bottom: 10px;
	    }

	    .news-info-detail {
	      height: 49px;
	      display: flex;
	      align-items: center;
	      font-size: 14px;

	      .news-time {
	        width: 60px;
	        height: 50px;
	        display: flex;
	        flex-direction: column;
	        align-items: center;
	        margin-right: 8px;
					position: relative;
					padding-right: 10px;

					&::after {
						&:extend(.gray-border);
						width: 1px;
						height: 100%;
						left: 100%;
						opacity: .3;
					}

	        > b {
						height: 24px;
						font-size: 17px;
						font-family: PingFangSC-Semibold, PingFang SC;
						font-weight: 600;
						color: #B7B7B7;
						line-height: 24px;
	        }

	        > span {
						height: 20px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #787878;
						line-height: 20px;
	        }
	      }

	      .news-title {
					flex: 1;
	        &:extend(.line2);
					padding-right: 84px;
	        height: 48px;
	        font-size: 14px;
	        font-family: PingFangSC-Medium, PingFang SC;
	        font-weight: 400;
	        color: #787878;
					line-height: 24px;
	      }
	    }

	    .card-more {
	    	position: absolute;
	    	right: 20px;
	    	top: 50%;
	    	transform: translateY(-50%);
	    }
	  }
	}

	.card-list-wrap {
		width: 284px;

		.card-header {
      width: 100%;
      position: relative;
      padding: 20px;
      display: flex;
      flex-direction: column;
			margin-bottom: 23px;

      &-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
        left: 0;
        top: 0;
        background: url(../../assets/images/train-bg.png) no-repeat center center;
        background-size: 100% 100%;
      }

      &-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 28px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 36px;
          height: 3px;
          background: #FFFFFF;
        }

        &-title {
          &:extend(.line2);
          width: 180px;
          height: 50px;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 25px;
        }
      }

      &-body {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 21px;
      }
    }
		.card-item {
			width: 100%;
			height: 160px;
			background: url(../../assets/images/contribution-card-bg.png) no-repeat center center;
			background-size: 100% 100%;
			position: relative;
			padding-left: 138px;
			padding-top: 30px;
			margin-bottom: 20px;

			&-bg {
				position: absolute;
				width: 96px;
				left: 38px;
				top: 37px;
			}

			&-info {
				width: 120px;

				&-title {
					width: 100%;
					height: 20px;
					font-size: 14px;
					font-family: SourceHanSerifSC-Medium, SourceHanSerifSC;
					font-weight: 500;
					color: #453C3C;
					line-height: 20px;
					margin-bottom: 4px;
				}

				&-little-title {
					height: 11px;
					font-size: 12px;
					font-family: SourceHanSerifSC-Medium, SourceHanSerifSC;
					font-weight: 500;
					color: #453C3C;
					margin-bottom: 11px;
				}

				&-desc {
					&:extend(.line3);
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #453C3C;
				}
			}
		}
	}
}

.flex {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.search-box {
	height: 31px;
	display: flex;
	margin-bottom: 23px;

	input {
		width: 243px;
		height: 31px;
		background: #F1F3F3;
		border: none;
    padding: 6px 15px;
    box-sizing: border-box;
	}

	.search-btn {
		width: 95px;
		height: 31px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #06AE63;
		font-size: 14px;
		font-family: SourceHanSansCN-Bold, SourceHanSansCN;
		font-weight: bold;
		color: #FFFFFF;
		cursor: pointer;
	}
}
</style>